<template>
  <div class="case-detail">
    <div class="container">
      <div class="back-link">
        <router-link to="/case">← 返回案例列表</router-link>
      </div>

      <article class="case-article">
        <header class="case-header">
          <h1>{{ caseData.title }}</h1>
          <div class="case-meta">
            <span class="company">{{ caseData.company }}</span>
            <span class="industry">{{ caseData.industry }}</span>
            <span class="date">{{ caseData.date }}</span>
          </div>
          <div class="case-tags">
            <span v-for="tag in caseData.tags" :key="tag" class="tag">{{ tag }}</span>
          </div>
        </header>

        <section class="case-section">
          <h2>项目背景</h2>
          <p>{{ caseData.background }}</p>
        </section>

        <section class="case-section">
          <h2>面临挑战</h2>
          <ul>
            <li v-for="challenge in caseData.challenges" :key="challenge">{{ challenge }}</li>
          </ul>
        </section>

        <section class="case-section">
          <h2>解决方案</h2>
          <p>{{ caseData.solution }}</p>
        </section>

        <section class="case-section">
          <h2>项目成果</h2>
          <div class="results-grid">
            <div v-for="result in caseData.results" :key="result.label" class="result-item">
              <div class="result-value">{{ result.value }}</div>
              <div class="result-label">{{ result.label }}</div>
            </div>
          </div>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaseDetail',
  data() {
    return {
      caseData: {
        title: '某大型制造企业数字化转型项目',
        company: 'ABC制造集团',
        industry: '制造业',
        date: '2025-12',
        tags: ['数字化转型', '制造业', '流程优化', '智能制造'],
        background: 'ABC制造集团是一家拥有30年历史的大型制造企业，面临传统生产模式效率低下、成本高企的问题。企业希望通过数字化转型提升竞争力。',
        challenges: [
          '生产流程依赖人工，效率低下',
          '数据分散，缺乏统一管理平台',
          '设备维护成本高，故障率较高',
          '供应链协同困难，库存积压严重'
        ],
        solution: '我们为企业量身定制了全面的数字化转型方案，包括建立智能生产系统、数据中台、设备预测性维护系统和供应链协同平台。通过分阶段实施，逐步实现生产流程的全面数字化。',
        results: [
          { value: '30%', label: '生产效率提升' },
          { value: '25%', label: '运营成本降低' },
          { value: '40%', label: '设备故障率下降' },
          { value: '20%', label: '库存周转率提升' }
        ]
      }
    }
  },
  created() {
    // 实际项目中这里应该根据路由参数从API获取具体案例数据
    const caseId = this.$route.params.id
    console.log('Case ID:', caseId)
  }
}
</script>

<style scoped>
.case-detail {
  min-height: 600px;
  padding: 40px 0 80px;
}

.back-link {
  margin-bottom: 32px;
}

.back-link a {
  color: var(--text-secondary);
  font-size: 14px;
  display: inline-flex;
  align-items: center;
}

.back-link a:hover {
  color: var(--brand-blue);
}

.case-article {
  max-width: 900px;
  margin: 0 auto;
}

.case-header {
  margin-bottom: 48px;
  padding-bottom: 32px;
  border-bottom: 1px solid var(--divider);
}

.case-header h1 {
  font-size: 42px;
  color: var(--text-primary);
  margin-bottom: 16px;
  line-height: 1.3;
}

.case-meta {
  display: flex;
  gap: 24px;
  margin-bottom: 16px;
}

.case-meta span {
  font-size: 14px;
  color: var(--text-secondary);
}

.case-meta .company {
  color: var(--brand-blue);
  font-weight: 500;
}

.case-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag {
  background-color: var(--porcelain-blue);
  color: var(--brand-blue);
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 13px;
}

.case-section {
  margin-bottom: 40px;
}

.case-section h2 {
  font-size: 24px;
  color: var(--text-primary);
  margin-bottom: 16px;
}

.case-section p {
  color: var(--text-secondary);
  line-height: 1.8;
  font-size: 16px;
}

.case-section ul {
  list-style: none;
  padding: 0;
}

.case-section li {
  color: var(--text-secondary);
  line-height: 1.8;
  font-size: 16px;
  padding: 8px 0;
  padding-left: 24px;
  position: relative;
}

.case-section li::before {
  content: '•';
  color: var(--brand-blue);
  font-weight: bold;
  position: absolute;
  left: 0;
}

.results-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 24px;
}

.result-item {
  background: linear-gradient(135deg, var(--porcelain-blue), var(--white));
  padding: 32px;
  border-radius: 8px;
  text-align: center;
  border: 1px solid var(--divider);
}

.result-value {
  font-size: 36px;
  font-weight: bold;
  color: var(--brand-blue);
  margin-bottom: 8px;
}

.result-label {
  color: var(--text-secondary);
  font-size: 14px;
}
</style>
